import React, { useMemo } from 'react';
import { SIDEBAR_CONFIG } from './sidebar.config';
import styles from './Sidebar.module.css';
import SidebarItem from './SidebarItem';

export default function Sidebar({ collapsed = false }) {
  const items = useMemo(() => SIDEBAR_CONFIG, []);

  return (
    <nav className={styles.nav} aria-label="Main navigation">
      <ul className={styles.list}>
        {items.map((item) => (
          <SidebarItem key={item.id} item={item} collapsed={collapsed} />
        ))}
      </ul>
    </nav>
  );
}

